import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { Prime } from '../../types/prime';

interface PrimeState {
  prime: Prime;
  setPrime: (prime: Prime) => void;
}

const usePrimeStore = create<PrimeState>()(
  devtools(
    persist(
      (set) => ({
        prime: { activeSubscription: false, primeEnabled: false },
        setPrime: (prime: Prime) => set({ prime: prime }),
      }),
      {
        name: 'prime-storage', // Unique name for the storage
      },
    ),
  ),
);

export default usePrimeStore;
